<!-- Botón de volver atrás - Parte superior izquierda -->
<div class="fixed top-20 left-16 z-40">
  <button type="button" (click)="goBack()"
    class="btn btn-ghost text-gray-700 hover:text-gray-900 hover:bg-gray-100 px-3 py-2 rounded-lg transition-colors font-medium">
    <span class="text-lg mr-1">←</span>
    <span>Volver</span>
  </button>
</div>

<div class="container mx-auto p-4 h-fit pt-20">

  <form [formGroup]="sparePartsForm" (ngSubmit)="onSubmit()" class="space-y-4 h-full mb-48 mt-24">
    <!-- Botón de auto-llenado para pruebas -->
    <div class="mb-4">
      <button type="button" (click)="autoFillForm()" class="btn btn-primary btn-sm">
        🔧 Auto-llenar formulario (Pruebas)
      </button>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

      <div class="form-control">
        <label class="label" for="orderDate">
          <span class="label-text">Fecha de la orden (compra)</span>
        </label>
        <input type="date" id="orderDate" formControlName="orderDate" class="input input-bordered"
          title="Fecha en que corresponde la compra; puede ser anterior a hoy.">
      </div>

      <div class="form-control">
        <label class="label" for="providerName">
          <span class="label-text">Nombre del proveedor</span>
        </label>
        <div class="flex gap-2 items-center">
          <input type="text" id="providerName" formControlName="providerName" class="input input-bordered flex-1"
            list="providersList" placeholder="Escribe o selecciona proveedor">
          <button type="button" class="btn btn-outline btn-sm" (click)="openManageProvidersModal()"
            title="Agregar o quitar proveedores">
            Gestionar
          </button>
        </div>
        <datalist id="providersList">
          <option *ngFor="let provider of providers" [value]="provider.name"></option>
        </datalist>
        <div *ngIf="providers.length === 0" class="text-xs text-gray-500 mt-1">
          Aún no hay proveedores guardados. Puedes escribir uno o agregarlo desde "Gestionar".
        </div>
      </div>
      <div class="form-control">
        <label class="label" for="providerPhone">
          <span class="label-text">Teléfono del proveedor</span>
        </label>
        <input type="text" id="providerPhone" formControlName="providerPhone" class="input input-bordered">
      </div>
      <div class="form-control">
        <label class="label" for="clientName">
          <span class="label-text">Nombre del cliente</span>
        </label>
        <input type="text" id="clientName" formControlName="clientName" class="input input-bordered">
      </div>
      <div class="form-control">
        <label class="label" for="clientPhone">
          <span class="label-text">Teléfono del cliente</span>
        </label>
        <input type="text" id="clientPhone" formControlName="clientPhone" class="input input-bordered">
      </div>
      <div class="form-control">
        <label class="label" for="employeeName">
          <span class="label-text">Nombre del empleado</span>
        </label>
        <!-- employeeNames -->
        <select id="employeeName" formControlName="employeeName" class="select select-bordered">
          <option *ngFor="let employee of employeeNames" [value]="employee">{{ employee }}</option>
        </select>
      </div>
      <div class="form-control">
        <label class="label" for="invoiceNumber">
          <span class="label-text">Numero de factura</span>
        </label>
        <input type="text" id="invoiceNumber" formControlName="invoiceNumber" class="input input-bordered">
      </div>
      <div class="form-control">
        <label class="label" for="siniestro">
          <span class="label-text">Siniestro</span>
        </label>
        <input type="text" id="siniestro" formControlName="siniestro" class="input input-bordered">
      </div>
      <div class="form-control">
        <label class="label" for="orderNumber">
          <span class="label-text">Número de orden</span>
        </label>
        <input type="text" id="orderNumber" formControlName="orderNumber" class="input input-bordered">
      </div>
      <div class="form-control">
        <label class="label" for="deliveryAddress">
          <span class="label-text">Dirección de entrega</span>
        </label>
        <input type="text" id="deliveryAddress" formControlName="deliveryAddress" class="input input-bordered">
      </div>
      <div class="form-control">
        <label class="label" for="carMakeModel">
          <span class="label-text">Marca/Modelo del coche</span>
        </label>
        <input type="text" id="carMakeModel" formControlName="carMakeModel" class="input input-bordered">
      </div>
      <div class="form-control">
        <label class="label" for="isExport">
          <span class="label-text">¿Es exportación?</span>
        </label>
        <select id="isExport" formControlName="isExport" class="select select-bordered">
          <option value="si">Si</option>
          <option value="no">No</option>
        </select>
      </div>

      <div class="form-control">
        <label class="label" for="clienteUY">
          <span class="label-text">Cliente UY</span>
        </label>
        <select id="clienteUY" formControlName="clienteUY" class="select select-bordered">
          <option value="AUTOCOMERCIAL">AUTOCOMERCIAL</option>
          <option value="SERIMPORT">SERIMPORT</option>
        </select>
      </div>

      <div class="form-control">
        <label class="label" for="workshopId">
          <span class="label-text">Taller asignado</span>
        </label>

        <!-- Dropdown personalizado -->
        <div class="relative workshop-dropdown-container">
          <div class="select select-bordered w-full cursor-pointer flex items-center justify-between"
            (click)="toggleWorkshopDropdown()">
            <span>
              {{ getSelectedWorkshopDisplay() }}
            </span>
            <i class="fas" [ngClass]="showWorkshopDropdown ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </div>

          <!-- Opciones del dropdown -->
          <div *ngIf="showWorkshopDropdown"
            class="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">

            <!-- Opción: Agregar taller -->
            <div class="px-4 py-2 hover:bg-blue-50 cursor-pointer text-blue-600 font-semibold flex items-center"
              (click)="selectWorkshop('add-new')">
              + Agregar taller
            </div>

            <!-- Opción: Sin asignar -->
            <div class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center" (click)="selectWorkshop('null')">
              Sin asignar
            </div>

            <!-- Opciones de talleres -->
            <div *ngFor="let workshop of workshops; trackBy: trackByWorkshopId"
              class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center justify-between group">
              <span (click)="selectWorkshop(workshop.workshopId.toString())">
                {{ workshop.name }}{{ workshop.city ? ' (' + workshop.city + ')' : '' }}{{ workshop.address ? ' - ' +
                workshop.address : '' }}
              </span>
              <button type="button" (click)="$event.stopPropagation(); openWorkshopInfo(workshop.workshopId)"
                class="btn btn-circle btn-ghost btn-xs opacity-0 group-hover:opacity-100 transition-opacity"
                title="Ver información del taller">
                <i class="fas fa-info-circle text-blue-500"></i>
              </button>
            </div>

            <!-- Mensaje si no hay talleres -->
            <div *ngIf="workshops.length === 0" class="px-4 py-2 text-gray-400 italic">
              No hay talleres disponibles
            </div>
          </div>
        </div>

        <div *ngIf="workshops.length === 0" class="text-sm text-warning mt-1">
          No hay talleres disponibles. <a (click)="openCreateWorkshopModal()"
            class="link link-primary cursor-pointer">Crear uno ahora</a>
        </div>
      </div>

      <!-- enviar -->
      <div class="form-control">
        <label class="label" for="sendYesOrNo">
          <span class="label-text">Enviar</span>
        </label>
        <select id="sendYesOrNo" formControlName="sendYesOrNo" class="select select-bordered">
          <option value="true">Si</option>
          <option value="false">No</option>
          <option value="INDEFINIDO">INDEFINIDO</option>
        </select>
      </div>

      <div class="form-control md:col-span-2">
        <label class="label" for="orderEmergentComment">
          <span class="label-text">Comentario emergente (orden)</span>
        </label>
        <input type="text" id="orderEmergentComment" formControlName="emergentComment" class="input input-bordered">
      </div>
    </div>
    <h3 class="text-lg font-semibold">Repuestos</h3>

    <div formArrayName="spareParts" class="space-y-4 border-solid">
      <div *ngFor="let sparePart of spareParts.controls; let i=index" [formGroupName]="i"
        class="spare-part space-y-2 border-4 p-4 rounded"
        [ngClass]="getSparePartHighlightClass(sparePart)">
        <div class="form-control">
          <label class="label w-full justify-end" for="sparePartName">
            <span class="label-text text-xl">Repuesto numero: {{ i + 1 }}</span>
          </label>
          <label class="label" for="sparePartName">
            <span class="label-text">Nombre del repuesto (General)</span>
          </label>
          <input type="text" formControlName="sparePartName" class="input input-bordered">

          <label class="label" for="sparePartNameEs">
            <span class="label-text">Nombre en Español (Para etiquetas)</span>
          </label>
          <input type="text" formControlName="sparePartNameEs" class="input input-bordered"
            placeholder="Nombre en español">

          <label class="label" for="sparePartNamePt">
            <span class="label-text">Nombre en Portugués (Para Excel)</span>
          </label>
          <input type="text" formControlName="sparePartNamePt" class="input input-bordered"
            placeholder="Nome em português">
        </div>
        <div class="form-control">
          <label class="label" for="unitPrice">
            <span class="label-text">Costo unitario</span>
          </label>
          <div class="relative">
            <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500">R$</span>
            <input type="text" formControlName="unitPrice" class="w-full input input-bordered pl-8"
              (input)="handleNumericInput($event)" (blur)="handleNumericBlur($event)"
              (focus)="handleNumericFocus($event)" placeholder="0,00">
          </div>
        </div>

        <div class="form-control">
          <label class="label" for="valorDeVenta">
            <span class="label-text">Valor de venta</span>
          </label>
          <div class="relative">
            <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500">$</span>
            <input type="text" formControlName="valorDeVenta" class="w-full input input-bordered pl-8"
              (input)="handleNumericInput($event)" (blur)="handleNumericBlur($event)"
              (focus)="handleNumericFocus($event)" placeholder="0,00">
          </div>
        </div>

        <div class="form-control">
          <label class="label" for="amount">
            <span class="label-text">Cantidad</span>
          </label>
          <input type="text" formControlName="amount" class="input input-bordered" (input)="handleNumericInput($event)"
            (blur)="handleNumericBlur($event)" (focus)="handleNumericFocus($event)" placeholder="1">
        </div>
        <div class="form-control">
          <label class="label" for="taxNote">
            <span class="label-text">Nota fiscal</span>
          </label>
          <input type="text" formControlName="taxNote" class="input input-bordered">
        </div>
        <div class="form-control">
          <label class="label" for="ncm">
            <span class="label-text">NCM</span>
          </label>
          <input type="text" formControlName="ncm" class="input input-bordered">
        </div>
        <div class="form-control">
          <label class="label" for="productCode">
            <span class="label-text">Código del producto</span>
          </label>
          <input type="text" formControlName="productCode" class="input input-bordered">
        </div>

        <div class="form-control">
          <label class="label" for="providerNamePart">
            <span class="label-text">Proveedor del repuesto</span>
          </label>
          <input type="text" id="providerNamePart" formControlName="providerName" class="input input-bordered"
            placeholder="Si queda vacío usa el proveedor de la orden">
        </div>

        <div class="form-control">
          <label class="label" for="arrivalDays">
            <span class="label-text">Días hasta la llegada esperada</span>
          </label>
          <!-- Input para ingresar la cantidad de días -->
          <input type="number" id="arrivalDays" formControlName="arrivalDays" class="input input-bordered"
            placeholder="Ingrese días" #daysUntilArrive />

        </div>

        <!-- enviar -->
        <div class="form-control">
          <label class="label" for="codBr">
            <span class="label-text">Código BR</span>
          </label>
          <input type="text" formControlName="codBr" class="input input-bordered">
        </div>


        <div class="form-control">
          <label class="label" for="grossWheight">
            <span class="label-text">Peso Bruto</span>
          </label>
          <div class="relative">
            <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500">kg</span>
            <input type="text" id="grossWheight" class="w-full input input-bordered pl-10"
              (input)="handleNumericInput($event)" (blur)="handleNumericBlur($event)"
              (focus)="handleNumericFocus($event)" placeholder="0,00">
          </div>
        </div>

        <div class="form-control">
          <label class="label" for="netWheight">
            <span class="label-text">Peso Líquido</span>
          </label>
          <div class="relative">
            <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500">kg</span>
            <input type="text" id="netWheight" class="w-full input input-bordered pl-10"
              (input)="handleNumericInput($event)" (blur)="handleNumericBlur($event)"
              (focus)="handleNumericFocus($event)" placeholder="0,00">
          </div>
        </div>


        <div class="form-control">
          <label class="label" for="country">
            <span class="label-text">País de origen</span>
          </label>
          <input type="text" formControlName="country" class="input input-bordered">
        </div>

        <div class="form-control">
          <label class="label" for="isDamaged">
            <span class="label-text">¿Esta dañado?</span>
          </label>
          <select id="isDamaged" formControlName="isDamaged" class="select select-bordered">
            <option *ngFor="let option of damagedStateOptions" [value]="option.value">{{ option.label }}</option>
          </select>
        </div>

        <div class="form-control">
          <label class="label" for="needReview">
            <span class="label-text">¿Necesita revisión?</span>
          </label>
          <select id="needReview" formControlName="needReview" class="select select-bordered">
            <option [ngValue]="false">No</option>
            <option [ngValue]="true">Sí</option>
          </select>
        </div>

        <div class="form-control">
          <div class="flex flex-wrap items-center gap-2">
            <label class="label cursor-pointer justify-start gap-2 py-0" [attr.for]="'isFant-' + i">
              <input [id]="'isFant-' + i" type="checkbox" formControlName="isFant" class="checkbox checkbox-primary"
                (change)="onSparePartFantChanged(i, $any($event.target).checked)">
              <span class="label-text">Fant?</span>
            </label>
            <span class="inline-flex items-center gap-1" *ngIf="sparePart.get('isFant')?.value">
              <button type="button" title="Puede esperar" (click)="setSparePartFantUrgency(i, 'green')"
                class="w-4 h-4 rounded-full bg-green-500 border-2"
                [class.border-gray-900]="sparePart.get('fantUrgency')?.value === 'green'"
                [class.border-transparent]="sparePart.get('fantUrgency')?.value !== 'green'"
                [class.ring-2]="sparePart.get('fantUrgency')?.value === 'green'"
                [class.ring-green-800]="sparePart.get('fantUrgency')?.value === 'green'"></button>
              <button type="button" title="Atención" (click)="setSparePartFantUrgency(i, 'yellow')"
                class="w-4 h-4 rounded-full bg-yellow-400 border-2"
                [class.border-gray-900]="sparePart.get('fantUrgency')?.value === 'yellow'"
                [class.border-transparent]="sparePart.get('fantUrgency')?.value !== 'yellow'"
                [class.ring-2]="sparePart.get('fantUrgency')?.value === 'yellow'"
                [class.ring-yellow-700]="sparePart.get('fantUrgency')?.value === 'yellow'"></button>
              <button type="button" title="Urgente" (click)="setSparePartFantUrgency(i, 'red')"
                class="w-4 h-4 rounded-full bg-red-500 border-2"
                [class.border-gray-900]="sparePart.get('fantUrgency')?.value === 'red'"
                [class.border-transparent]="sparePart.get('fantUrgency')?.value !== 'red'"
                [class.ring-2]="sparePart.get('fantUrgency')?.value === 'red'"
                [class.ring-red-800]="sparePart.get('fantUrgency')?.value === 'red'"></button>
            </span>
          </div>
        </div>

        <div class="form-control">
          <label class="label cursor-pointer justify-start gap-2" for="recompra">
            <input id="recompra" type="checkbox" formControlName="recompra" class="checkbox checkbox-warning">
            <span class="label-text">Recompra</span>
          </label>
        </div>

        <div class="form-control">
          <label class="label cursor-pointer justify-start gap-2" for="control">
            <input id="control" type="checkbox" formControlName="control" class="checkbox checkbox-info">
            <span class="label-text">Control</span>
          </label>
        </div>

        <!-- comentario -->
        <div class="form-control">
          <label class="label" for="comments">
            <span class="label-text">Comentarios</span>
          </label>
          <input type="text" formControlName="comments" class="input input-bordered">
        </div>

        <div class="form-control">
          <label class="label" for="partEmergentComment">
            <span class="label-text">Comentario emergente</span>
          </label>
          <input type="text" id="partEmergentComment" formControlName="emergentComment" class="input input-bordered">
        </div>

        <!-- Remito -->
        <div class="form-control">
          <label class="label" for="shippingReceipt">
            <span class="label-text">Remito</span>
          </label>
          <input type="text" formControlName="shippingReceipt" class="input input-bordered">
        </div>

        <button type="button" class="btn cancel-button" (click)="removeSparePart(i)">Eliminar repuesto</button>
      </div>
    </div>
    <div class="flex justify-between mt-4 p-4">
      <button type="button" class="btn add-button" (click)="addSparePart()">Agregar repuesto</button>
      <div class="flex gap-2">
        <button type="button" class="btn btn-warning" (click)="autoFillForm()">🔧 Auto-completar (Prueba)</button>
        <button type="submit" class="btn confirm-button">Enviar</button>
      </div>
    </div>

  </form>
</div>

<div
  class="text-center w-full h-full fixed inset-0 flex items-center justify-center bottom-0 content-center bg-opacity-40 bg-slate-500"
  *ngIf="orderSending">
  <div role="status">
    <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
      viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="currentColor" />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentFill" />
    </svg>
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div *ngIf="showLowSaleRatioConfirmModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 w-full max-w-2xl mx-4" (click)="$event.stopPropagation()">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-semibold text-red-700">Confirmar guardado</h3>
      <button type="button" (click)="cancelLowSaleRatioConfirmation()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <p class="text-sm text-gray-700 mb-2">
      Hay repuestos con <strong>V.Venta / P.Unitario menor o igual a 11</strong>.
    </p>
    <p class="text-sm text-gray-700 mb-3">¿Deseas guardar la orden de todas formas?</p>

    <div class="max-h-52 overflow-y-auto border border-red-200 bg-red-50 rounded p-3 mb-4">
      <p class="text-sm font-medium text-red-800 mb-2">Repuestos que no cumplen:</p>
      <ul class="list-disc list-inside text-sm text-red-700 space-y-1">
        <li *ngFor="let label of lowSaleRatioViolationLabels">{{ label }}</li>
      </ul>
    </div>

    <div class="flex justify-end gap-2">
      <button type="button" (click)="cancelLowSaleRatioConfirmation()"
        class="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-700">
        Cancelar
      </button>
      <button type="button" (click)="confirmLowSaleRatioAndSubmit()"
        class="px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white">
        Guardar igual
      </button>
    </div>
  </div>
</div>

<!-- Modal para gestionar proveedores -->
<div *ngIf="showManageProvidersModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 w-full max-w-lg mx-4">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-semibold">Gestionar proveedores</h3>
      <button type="button" (click)="closeManageProvidersModal()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <form [formGroup]="manageProviderForm" (ngSubmit)="createProvider()" class="space-y-3">
      <div class="form-control">
        <label class="label">
          <span class="label-text">Agregar proveedor</span>
        </label>
        <div class="flex gap-2">
          <input type="text" formControlName="name" class="input input-bordered flex-1" placeholder="Nombre proveedor">
          <button type="submit" class="btn btn-primary" [disabled]="manageProviderForm.invalid || creatingProvider">
            <span *ngIf="creatingProvider" class="loading loading-spinner loading-sm mr-2"></span>
            Agregar
          </button>
        </div>
      </div>
    </form>

    <div class="mt-5">
      <p class="font-medium mb-2">Opciones actuales</p>
      <div class="border rounded-lg max-h-64 overflow-y-auto">
        <div *ngFor="let provider of providers"
          class="px-3 py-2 border-b last:border-b-0 flex justify-between items-center">
          <span>{{ provider.name }}</span>
          <button type="button" class="btn btn-ghost btn-xs text-red-500 hover:text-red-700"
            [disabled]="deletingProviderId === provider.providerId" (click)="deleteProvider(provider)">
            <span *ngIf="deletingProviderId === provider.providerId" class="loading loading-spinner loading-xs"></span>
            <span *ngIf="deletingProviderId !== provider.providerId">Quitar</span>
          </button>
        </div>
        <div *ngIf="providers.length === 0" class="px-3 py-2 text-gray-500 italic">
          No hay proveedores en el catálogo.
        </div>
      </div>
    </div>

    <div class="flex justify-end mt-4">
      <button type="button" (click)="closeManageProvidersModal()" class="btn btn-ghost">Cerrar</button>
    </div>
  </div>
</div>

<!-- Modal para crear nuevo taller -->
<div *ngIf="showCreateWorkshopModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 w-full max-w-md mx-4">
    <h3 class="text-lg font-semibold mb-4">Crear Nuevo Taller</h3>

    <form [formGroup]="createWorkshopForm" (ngSubmit)="createWorkshop()">
      <div class="space-y-4">
        <div class="form-control">
          <label class="label">
            <span class="label-text">Nombre del taller *</span>
          </label>
          <input type="text" formControlName="name" class="input input-bordered" placeholder="Ej: Taller Central"
            required>
        </div>

        <div class="form-control">
          <label class="label">
            <span class="label-text">Dirección</span>
          </label>
          <input type="text" formControlName="address" class="input input-bordered" placeholder="Dirección del taller">
        </div>

        <div class="form-control">
          <label class="label">
            <span class="label-text">Teléfono</span>
          </label>
          <input type="text" formControlName="phoneNumber" class="input input-bordered"
            placeholder="Número de teléfono">
        </div>

        <div class="form-control">
          <label class="label">
            <span class="label-text">Ciudad *</span>
          </label>
          <input type="text" formControlName="city" class="input input-bordered" placeholder="Ej: Montevideo" required>
        </div>

        <div class="form-control">
          <label class="label">
            <span class="label-text">Departamento</span>
          </label>
          <input type="text" formControlName="department" class="input input-bordered" placeholder="Ej: Montevideo">
        </div>

        <div class="form-control">
          <label class="label">
            <span class="label-text">Empresa</span>
          </label>
          <select formControlName="company" class="select select-bordered">
            <option value="AUTOCOMERCIAL">AUTOCOMERCIAL</option>
            <option value="SERIMPORT">SERIMPORT</option>
          </select>
        </div>
      </div>

      <div class="flex justify-end space-x-2 mt-6">
        <button type="button" (click)="cancelCreateWorkshop()" class="btn btn-ghost">
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="createWorkshopForm.invalid || creatingWorkshop">
          <span *ngIf="creatingWorkshop" class="loading loading-spinner loading-sm mr-2"></span>
          Crear Taller
        </button>
      </div>
    </form>
  </div>
</div>
<!-- Modal para mostrar información del taller -->
<div *ngIf="showWorkshopInfoModal && selectedWorkshopInfo"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 w-full max-w-md mx-4">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-semibold">Información del Taller</h3>
      <button (click)="closeWorkshopInfo()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="space-y-3">
      <div>
        <label class="text-sm font-medium text-gray-600">Nombre:</label>
        <p class="text-gray-900">{{ selectedWorkshopInfo.name }}</p>
      </div>

      <div *ngIf="selectedWorkshopInfo.address">
        <label class="text-sm font-medium text-gray-600">Dirección:</label>
        <p class="text-gray-900">{{ selectedWorkshopInfo.address }}</p>
      </div>

      <div *ngIf="selectedWorkshopInfo.phoneNumber">
        <label class="text-sm font-medium text-gray-600">Teléfono:</label>
        <p class="text-gray-900">{{ selectedWorkshopInfo.phoneNumber }}</p>
      </div>

      <div *ngIf="selectedWorkshopInfo.city">
        <label class="text-sm font-medium text-gray-600">Ciudad:</label>
        <p class="text-gray-900">{{ selectedWorkshopInfo.city }}</p>
      </div>

      <div *ngIf="selectedWorkshopInfo.department">
        <label class="text-sm font-medium text-gray-600">Departamento:</label>
        <p class="text-gray-900">{{ selectedWorkshopInfo.department }}</p>
      </div>

      <div *ngIf="selectedWorkshopInfo.company">
        <label class="text-sm font-medium text-gray-600">Empresa:</label>
        <p class="text-gray-900">{{ selectedWorkshopInfo.company }}</p>
      </div>
    </div>

    <div class="flex justify-end gap-2 mt-6">
      <button (click)="openEditWorkshopModal()" class="btn btn-primary">
        Editar
      </button>
      <button (click)="closeWorkshopInfo()" class="btn btn-ghost">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- Modal para editar taller -->
<div *ngIf="showEditWorkshopModal && selectedWorkshopInfo"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 w-full max-w-lg mx-4">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-semibold">Editar taller</h3>
      <button (click)="closeEditWorkshopModal()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <form [formGroup]="editWorkshopForm" (ngSubmit)="saveWorkshopEdit()" class="space-y-4">
      <div>
        <label class="label">
          <span class="label-text">Nombre</span>
        </label>
        <input type="text" formControlName="name" class="input input-bordered w-full" />
      </div>

      <div>
        <label class="label">
          <span class="label-text">Dirección</span>
        </label>
        <input type="text" formControlName="address" class="input input-bordered w-full" />
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="label">
            <span class="label-text">Teléfono</span>
          </label>
          <input type="text" formControlName="phoneNumber" class="input input-bordered w-full" />
        </div>
        <div>
          <label class="label">
            <span class="label-text">Ciudad</span>
          </label>
          <input type="text" formControlName="city" class="input input-bordered w-full" />
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="label">
            <span class="label-text">Departamento</span>
          </label>
          <input type="text" formControlName="department" class="input input-bordered w-full" />
        </div>
        <div>
          <label class="label">
            <span class="label-text">Empresa</span>
          </label>
          <select formControlName="company" class="select select-bordered w-full">
            <option value="AUTOCOMERCIAL">AUTOCOMERCIAL</option>
            <option value="SERIMPORT">SERIMPORT</option>
          </select>
        </div>
      </div>

      <div>
        <label class="label">
          <span class="label-text">Aplicar cambios</span>
        </label>
        <div class="flex flex-col gap-2">
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="radio" name="workshopEditScope" class="radio radio-primary"
              [checked]="workshopEditScope === 'order-only'" (change)="workshopEditScope = 'order-only'" />
            <span>Solo para esta orden</span>
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="radio" name="workshopEditScope" class="radio radio-primary"
              [checked]="workshopEditScope === 'global'" (change)="workshopEditScope = 'global'" />
            <span>Actualizar taller en BDD (permanente)</span>
          </label>
        </div>
      </div>

      <div class="flex justify-end gap-2 pt-2">
        <button type="button" (click)="closeEditWorkshopModal()" class="btn btn-ghost">
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="editWorkshopForm.invalid || updatingWorkshop">
          <span *ngIf="updatingWorkshop" class="loading loading-spinner loading-sm mr-2"></span>
          Guardar cambios
        </button>
      </div>
    </form>
  </div>
</div>